import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { dropHasSession, hasSession, logoutSession } from "../auth/authSession";

// const useIdleLogout = (timeout = 21600000) => {
//   const location = useLocation();

//   useEffect(() => {
//     if (!hasSession() || location.pathname === "/login") return undefined;

//     let timeoutId;

//     const logout = async () => {
//       await logoutSession();
//       if (window.location.pathname !== "/login") {
//         window.location.href = "/login";
//       }
//     };

//     const resetTimer = () => {
//       clearTimeout(timeoutId);
//       timeoutId = setTimeout(logout, timeout);
//     };

//      const events = [
//       "mousemove",
//       "mousedown",
//       "keydown",
//       "scroll",
//       "click",
//       "touchstart",
//     ];

//     events.forEach((event) => window.addEventListener(event, resetTimer));
//     resetTimer();

//     return () => {
//       clearTimeout(timeoutId);
//       events.forEach((event) => window.removeEventListener(event, resetTimer));
//     };
//   }, [location.pathname, timeout]);
// };

// export default useIdleLogout;
const LAST_ACTIVITY_KEY = "procurement.lastActivity";
const LOGOUT_KEY = "procurement.logout";

// Testing: 1 minute
// Production 6 hours = 21600000
const useIdleLogout = (timeout = 21600000) => {
  const location = useLocation();

  useEffect(() => {
    if (!hasSession() || location.pathname === "/login") {
      return undefined;
    }

    let intervalId;
    let lastWrite = 0;
    let isLoggingOut = false;

    const goToLogin = () => {
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    };

    const logout = async () => {
      if (isLoggingOut) return;

      isLoggingOut = true;

      try {
        await logoutSession();
      } finally {
        localStorage.removeItem(LAST_ACTIVITY_KEY);
        goToLogin();
      }
    };

    const updateActivity = () => {
      if (isLoggingOut) return;

      const now = Date.now();

      // Prevent excessive writes from mousemove.
      if (now - lastWrite < 1000) return;

      lastWrite = now;

      localStorage.setItem(
        LAST_ACTIVITY_KEY,
        now.toString()
      );
    };

    const checkIdle = () => {
      if (isLoggingOut) return;

      const lastActivity = Number(
        localStorage.getItem(LAST_ACTIVITY_KEY)
      );

      // Do NOT create a new session/activity here.
      if (!lastActivity) {
        logout();
        return;
      }

      const inactiveTime = Date.now() - lastActivity;

      if (inactiveTime >= timeout) {
        logout();
      }
    };

    const handleStorage = (event) => {
      // Another tab logged out.
      if (event.key === LOGOUT_KEY && event.newValue) {
        isLoggingOut = true;
        dropHasSession();
        goToLogin();
      }
    };

    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "click",
      "touchstart",
    ];

    events.forEach((event) =>
      window.addEventListener(event, updateActivity)
    );

    // Listen for actions from other tabs.
    window.addEventListener("storage", handleStorage);

    // Create activity timestamp when session starts.
    if (!localStorage.getItem(LAST_ACTIVITY_KEY)) {
      localStorage.setItem(
        LAST_ACTIVITY_KEY,
        Date.now().toString()
      );
    }

    // For testing use 5 seconds.
    intervalId = setInterval(checkIdle, 30000);

    return () => {
      clearInterval(intervalId);

      events.forEach((event) =>
        window.removeEventListener(event, updateActivity)
      );

      window.removeEventListener(
        "storage",
        handleStorage
      );
    };
  }, [location.pathname, timeout]);
};

export default useIdleLogout;